import React from "react";
import Signature from "@uiw/react-signature";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function SignatureInput(props) {
  const { ref, label } = props;
  const clearSignature = () => ref.current?.clear();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "10px",
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <Typography variant="body1">{label}</Typography>
      <Signature
        ref={ref}
        width={5}
        height={1}
        options={{
          size: 6,
          smoothing: 0.46,
          thinning: 0.73,
          streamline: 0.5,
          easing: (t) => t,
          simulatePressure: true,
          last: true,
          start: {
            cap: true,
            taper: 0,
            easing: (t) => t,
          },
          end: {
            cap: true,
            taper: 0,
            easing: (t) => t,
          },
        }}
      />
      <Button variant="contained" onClick={clearSignature}>
        Clear
      </Button>
    </div>
  );
}
